// removed by extract-text-webpack-plugin
module.exports = {"alert-sm":"_1TaYIdOlJzsZUyqO4BTqz9"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Customer/Zendesk.scss
 ** module id = 990
 ** module chunks = 0
 **/